import { jsx as _jsx } from "react/jsx-runtime";
import { createSvgIcon } from '../create-svg-icon';
export const ArrowDropDownIcon = createSvgIcon(_jsx("path", { d: "m7 10 5 5 5-5H7z" }), 'ArrowDropDownOutlined');
